 <template>
    <split-pane  :min-percent='10' :default-percent='35' split="vertical" style="background:white; height:100%">
        <template slot="paneL" >
            <div class="ve-list-page ve-list-page--embedded ve-list-page--pane">
            <!-- <div style=" display:flex; width:100%;min-width:900px; background:#fff;line-height:30px;border-bottom:2px solid #389;padding-top:3px"> -->   
            <div style="display:flex; border-bottom:2px solid #389;padding-top:2px ">
                <div style=" margin-left:2px;font-size:12px;margin-right:5px;line-height:30px;width:30px; ">字段 </div>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:100px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" v-model="txtparam" @keyup.native.enter="qryTabData" size="small" style="width:280px ;height:30px;  ">
                    <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 
                <el-link  @click="runRep" :underline="false" style="width:60px; ">
                    <i class="iconfont icon-zhanghuguanli-baobiao" style="font-size:14px; color:#409eff"></i>
                    <span style="font-size:12px;  font-weight:600;margin-left:5px;">报表</span>
                </el-link>
<!--                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>-->
<!--                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>-->
<!-- -->
            </div>
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol"
                    :table-data="tabData"
                    :column-hidden-option="columnHiddenOption"
                    :border-around="true"
                    :border-x="true"
                    :border-y="true"
                    :fixed-header="true"
                    row-key-field-name="PKSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :event-custom-option="eventCustomOption"
                    :max-height="tabHeight"
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false}"
                    ref="tabref"
                    v-loading="v_loading">
            </ve-table>
            </div>
            <div style="margin-top:5px; display:flex;background:white;font-size:12px;font-size:10px ;padding-left:4px" class="ve-list-page__pagination">
                <div style="float: left;font-size:12px">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
            </div> 
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 报表-->
            <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="runWin" width="340px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
                </div> 
                <div style="display:flex;  ">
                    <div style="font-size:12px;width:100px;line-height:35px;color:red">物料类别</div>
                    <el-select  v-model="v_type" style="width:100%" filterable >
                        <span v-for="(item ,index) in tyArr" :key='index'>
                            <el-option :label="item.MATTYNM" :value="item.MATTY" ></el-option>
                        </span>
                    </el-select>
                </div>
                <div style="display:flex; margin-top:15px;margin-bottom:15px">
                    <div style="font-size:12px;width:100px;line-height:35px">起始物料编码</div>
                    <el-input placeholder="请输入完整物料编码"  v-model="v_frmatno"  style="width:100%"  ></el-input>   
                </div>
                <div style="display:flex; margin-top:15px;margin-bottom:15px">
                    <div style="font-size:12px;width:100px;line-height:35px">结束物料编码</div>
                    <el-input placeholder="请输入完整物料编码"  v-model="v_tomatno"  style="width:100%"  ></el-input>   
                </div>
                <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
                    <span style="float:right">
                        <el-button type="info" @click="runWin=false" size="small" style="margin-left:50px;" icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button   @click="repBtn" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > 确定 </el-button> 
                    </span>
                </div> 
            </el-dialog>
            </div>
        </template>
        <template slot="paneR">
            <div class="one-toolbar"><span class="spanRow">条码明细</span></div>
            <div style=" margin-left:2px;text-align:center;display:flex;flex-wrap: wrap;overflow-y:auto;height:85vh"> 
                <div v-for="(item,index) in tabData" :key="index" style="display:flex;border:1px solid #ccc;height:90px;margin-left:10px;width:140px;margin-right:20px;margin-top:15px"> 
                    <!-- <div style=" margin-top:1px;padding-left:1px;padding-bottom:1px">
                        <qrcode 
                            :url="item.IDSEQ" 
                            :colorDark="v_color" 
                            :colorLight="v_bgcolor"  
                            :wid="v_width" 
                            :hei="v_height"  >
                        </qrcode>
                    </div> -->
                    <el-link :underline="false" @click="repShow(item.IDSEQ)">
                        <div :id="'refid-'+index"   style=" padding-left:1px;padding-bottom:1px"></div> 
                    </el-link>
                    <div style="margin-left:4px;text-align:left">
                        <div>{{item.IDNO}}</div>
                        <div class="div-flow">{{item.MATNM}}</div>
                    </div>
                </div>
            
            </div>
            <!-- report preview -->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
            </el-dialog>
            <VeColumnConfigDialog
                :visible="fieldSettingDialog.visible"
                :rows="fieldSettingDialog.rows"
                :loading="fieldSettingDialog.loading"
                :error="fieldSettingDialog.error"
                :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                :drag-group-field="fieldSettingDialog.dragGroupField"
                :language="$store.state.lang"
                @update:visible="fieldSettingDialog.visible = $event"
                @change="updateFieldSettingsDraft"
                @confirm="saveFieldSettingsDialog"
                @reset="resetFieldSettingsDialog"
                @close="closeFieldSettingsDialog"
            />
 
        </template>
    </split-pane>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
//import qrcode from 'vue_qrcodes'
import QRcode from "qrcodejs2"
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
//局部注册
export default {
    name:"sku_barcode",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '423831',
            fieldIdseq: '423831',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum'],
        })
    ],
    components: {
        VeColumnConfigDialog,
    },
    data () {
        return {
            promptWin:false,
            prompt:'',
            v_loading:false,
            disabled:false, //新增权限制
            tabData:[], //表数据
            tabArr:[], //表列 
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({
                    click: () => this.rowClick(row),
                }),
            },
            operArr:[],           
            runWin:false,
            oper:'like',
            txtparam:'',
            selparam:'MATNM',
            v_row:{},
            queryRequestId:0,
            repWin:false,
            repUrl:'',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_type:'',
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            allData:[],
            current:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_rmk:'test',  // url, 二维码输入的内容
            v_width:80, //二维码宽度
            v_height:86, //二维码高度
            v_imgw:60 , //二维码中间小图片宽度
            v_imgh:60 , //二维码中间小图片高度
            v_color:'#3498db', //二维码颜色
            v_bgcolor:'#ccc' , //二维码背景颜色
            tyArr:[],
            v_frmatno:'',
            v_tomatno:'',
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','','','','','V_MATTY_GP','').then(res=>{
            this.tyArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4265','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //查询数据
        this.$nextTick(()=>{
            this.getMatList('')
            
        })
        
    },
    computed: {
 
        tabHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 160) + 'px';
        }, 
    },
    created () {       
        if (this.v_username){ 
            
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        rowShow(){
            this.v_row = {}
            this.current = 1
            this.qryTabData()
        } ,
        repBtn(row){
            if (!this.v_type){
                this.promptWin =true
                this.prompt ='请选择物料类别'
            }else{
                this.repWin =true
                this.runWin =false
                this.repUrl =this.$store.state.repUrl+ 'barcode.cpt'+'&p_corpid='+this.v_corpid+'&p_matty='+this.v_type+'&p_fridno='+this.v_frmatno +'&p_toidno='+this.v_tomatno 
            }
        },
        runRep(){
            this.runWin =true
        },
        repShow(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ 'barcode.cpt'+'&p_corpid='+this.v_corpid+'&p_idseq='+row 
        },
        createQrCode(){
            this.$nextTick(()=>{
               // this.$refs.qrCodeDiv.innerHTML ='' //二维码清除,清除上一张的缓存
               this.tabData.forEach((item,index)=>{
                   document.getElementById('refid-' + index).innerHTML =''
                   new QRcode(document.getElementById('refid-' + index) ,{
                        text: item['IDSEQ'],
                        width:this.v_width,
                        height: this.v_height,
                        colorDark: this.v_color,
                        colorLight: this.v_bgcolor,
                        correctLevel: QRcode.CorrectLevel.M  //容错率 L/M/H
                    })
               })
                
            })
        },
        rowClick(row){
        },
        renderColumnHeader(item){
            const key = item.key
            return <VeTableQueryHeader
                title={item.title}
                edcss={key === 'STFG' ? 'select' : item.edcss}
                value={this.v_row[key]}
                operator={this.v_row[`#OPER${key}`]}
                options={key === 'STFG' ? [{ value: 'Y', label: this.$LANG('1781', '已审') }, { value: 'N', label: this.$LANG('1782', '未审') }] : []}
                on-input={(value) => this.$set(this.v_row, key, value)}
                on-operator-change={(value) => this.$set(this.v_row, `#OPER${key}`, value)}
                on-query={this.qryTabData}
            />
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end)
            this.createQrCode()
        },
        //数据明细
        getMatList(cond){
            this.v_loading =true       
            const requestId = ++this.queryRequestId
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+ ' order by modelnm,'+this.selparam+' desc',p_table:'V_BS_MATQRY'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage()
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        const table = this.$refs.tabref
                        if (table && typeof table.doLayout === 'function') table.doLayout()
                        this.createQrCode()
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                } 
            }).catch((error) => {
                if (requestId === this.queryRequestId) {
                    this.promptWin=true
                    this.prompt=error.message || this.$LANG('1641', '查询失败')
                }
            }).finally(() => {
                if (requestId === this.queryRequestId) this.v_loading=false
            })
        },
 
        getRowKey(row){
            return row.PKSEQ
        },
        //查询
        qryTabData(){
            let cond_=buildVeTableHeaderCondition(this.initCol, this.v_row, { typeOverrides: { STFG: 'select' } })
            cond_+=buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            this.current = 1
            this.getMatList(cond_)
             
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','423831','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result || []
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const key = item.key || item.KEY || item.FLDNO
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        const normalized = {
                            title,
                            key,
                            align: item.align,
                            width: item.width || item.WIDTH,
                            thide: item.THIDE || item.thide,
                            fhide: item.FHIDE || item.fhide,
                            edcss: item.EDCSS || item.edcss,
                            disabled: item.DISABLED || item.disabled,
                            sortable: item.SORTABLE || item.sortable,
                        }
                        vm.tabArr.push(normalized)
                        if (String(normalized.thide).toUpperCase() !== 'N') return
                        vm.vueCol.push({
                            field: key,
                            key,
                            title,
                            align: normalized.align,
                            width: Number(normalized.width) || 120,
                            sortable: normalized.sortable === 'N',
                            ellipsis: { showTitle: true },
                            renderHeaderCell: () => vm.renderColumnHeader(normalized),
                            renderBodyCell: ({ row }) => {
                                if (key === 'IDNO2') {
                                    return <el-link underline={false}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{row[key]}</div></el-link>
                                }
                                return <span>{row[key]}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        fixed: 'left',
                        align: 'center',
                        renderHeaderCell: () => <el-link on-click={() => vm.rowShow()} style="font-size:12px;color:#404eff"><el-tooltip content={vm.$LANG('1784', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link>,
                        renderBodyCell: ({ rowIndex }) => rowIndex + 1,
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .div-flow {
        overflow:hidden;
        text-overflow:ellipsis;
        // white-space:wrap;
        // width:60px;
        // height:75px;
        // line-height:20px;
        display: -webkit-box;
        -webkit-line-clamp:4;
        -webkit-box-orient:vertical; 
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
